<div class="p-4">
  <h1 class="leading-8 mb-1">Security and Credentials</h1>
  <p class="leading-5">Manage your login credentials and two-factor authentication.</p>
  <mat-divider class="!mt-4 !mb-8"></mat-divider>

  <div class="flex flex-col items-center gap-8 px-4 pb-8" *ngIf="profile">
    <div class="section flex">
      <div class="credentials">
        <div class="flex flex-col gap-2 mb-2">
          <h2>Credentials</h2>
          <p>
            Credentials are information you use to sign in to the portal. Email is compulsory, phone number is optional.
          </p>
        </div>
        <div class="bg-white px-5 mat-elevation-z1">
          <div class="item">
            <div class="content">
              <p>
                Email: <strong>{{ profile.email }}</strong>
              </p>
            </div>
            <a href="javascript:void(0)" (click)="showEmailModal()">Edit</a>
          </div>
          <mat-divider></mat-divider>
          <div class="item">
            <div class="content"><p>Change password</p></div>
            <a href="javascript:void(0)" (click)="showPasswordModal()">Edit</a>
          </div>
        </div>
      </div>
    </div>

    <div class="section flex">
      <div class="tfa">
        <div class="flex flex-col gap-2 mb-2">
          <h2>Two-factor authentication</h2>
          <p>
            Two-factor authentication provides another layer of security to your account. Your email needs to be
            verified before you can enable this feature.
          </p>
        </div>
        <div class="bg-white px-5 pb-5 mat-elevation-z1">
          <div class="status-container" [ngClass]="tfaInfo.tfaEnabled ? 'divider-auth mb-3' : 'mb-0'">
            <div class="flex justify-between content py-3">
              <div style="display: inline">
                <span class="text">Two-factor authentication</span>
              </div>
              <a
                href="javascript:void(0)"
                (click)="!!profile.email && setup2fa()"
                *ngIf="!tfaInfo.tfaEnabled"
                [ngClass]="{ 'anchor-disable': !profile.email }"
                >Enable</a
              >
              <a
                href="javascript:void(0)"
                (click)="!!profile.email && disable2fa()"
                *ngIf="tfaInfo.tfaEnabled && !securityCompliance.tfaRequired && !currentOrg?.isPartner"
                [ngClass]="{ 'anchor-disable': !profile.email }"
                >Disable</a
              >
            </div>
            <div class="ui banner warning message" *ngIf="!profile.email">
              <span>Please provide your email address to enable 2fa.</span>
            </div>
          </div>
          <div class="detail" *ngIf="tfaInfo.tfaEnabled">
            <div class="flex items-center title">
              <div class="header item-header">Your second step</div>
              <mat-icon matTooltip="After entering your password, you’ll be asked for a second verification step."
                >info</mat-icon
              >
            </div>
            <div class="items">
              <div class="box" *ngIf="tfaInfo.totpActivated">
                <img class="size-6" src="https://ui.b3networks.com/external/icon/authenticator.jpg" />
                <div class="box-container">
                  <div class="header">Authenticator app <strong>(Default)</strong></div>
                  <div class="description">From now on, you'll use Authenticator to sign in to your account.</div>
                </div>
                <div class="action">
                  <button mat-icon-button color="warn" (click)="showDeleteAuthenticationModal()">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
              <div class="box">
                <mat-icon>email</mat-icon>
                <div class="box-container">
                  <div class="header">Email <strong *ngIf="!tfaInfo.totpActivated">(Default)</strong></div>
                  <div class="description">
                    Use email to receive two-factor authentication codes. When logging in, a one-time code will be sent
                    to {{ profile.email }}
                  </div>
                </div>
              </div>
              <div class="box !mb-0">
                <mat-icon>lock</mat-icon>
                <div class="box-container">
                  <div class="header">Recovery key: {{ tfaInfo.recoveryKey }}</div>
                  <div class="description">
                    <p class="mb-2">
                      Recovery key can be used to access your account in case you lose access to your email and cannot
                      receive two-factor authentication codes.
                    </p>
                    <p class="mb-2">
                      <strong>
                        Saving your recovery key in a safe place can help keep you from being locked out of your
                        account.
                      </strong>
                    </p>
                  </div>
                  <div>
                    <a href="javascript:void(0)" (click)="createNewRecoveryCode()">Create new recovery key</a>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="!tfaInfo.totpActivated">
              <div class="flex items-center title">
                <div class="header item-header">Alternative second step</div>
                <mat-icon
                  matTooltip="Set up at least one backup option so that you can sign in even if your other second steps aren't
                  available."
                  >info</mat-icon
                >
              </div>
              <div class="items mb-0">
                <div class="box !mb-0">
                  <img class="size-6" src="https://ui.b3networks.com/external/icon/authenticator.jpg" />
                  <div class="box-container">
                    <div class="header">Authenticator app</div>
                    <div class="description">
                      <p>Use the Authenticator app to get free verification codes, even when your phone is offline.</p>
                    </div>
                    <div>
                      <a href="javascript:void(0)" (click)="showAuthenticatorModal()">Set up</a>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
